import { Info } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

/**
 * Значок «i» рядом с подписью поля: по наведению объясняет, что настройка
 * делает и на что влияет.
 *
 * Зачем отдельный компонент: подписи нужны почти каждому полю сложной формы
 * (настройки перевода эфира — два десятка параметров), а обвязка из
 * провайдера, триггера и содержимого одинакова. Повторять её у каждого поля
 * значит гарантированно разъехаться в отступах и размере иконки.
 *
 * Триггер — <span>, а не <button>: подпись поля часто уже лежит внутри
 * <label>, и вложенная кнопка перехватывала бы клик по подписи, мешая
 * попасть в само поле. Пояснение читается наведением и фокусом с клавиатуры.
 */
export function FieldHint({ text }: { text: string }) {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            tabIndex={0}
            role="note"
            aria-label={text}
            className="inline-flex cursor-help text-muted-foreground transition-colors hover:text-foreground focus-visible:text-foreground focus-visible:outline-none"
          >
            <Info className="h-3.5 w-3.5" aria-hidden="true" />
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs leading-relaxed">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
